// API configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// Helper function to get full API URL
export const getApiUrl = (path: string): string => {
  console.log('DEBUG: getApiUrl called with:', path);
  // In development, use proxy server on port 3001
  // In production, use relative paths (Cloudflare Pages Functions handle routing)
  if (process.env.NODE_ENV === 'development') {
    return `http://localhost:3001${path}`;
  }
  return path;
};